interface LandingViewArgs {
  isLandingRoute: boolean
  isNewChatRoute: boolean
  hasMessages: boolean
}

/** The landing shows on the landing and new-chat routes until the first message is sent. */
export function getIsLandingView({ isLandingRoute, isNewChatRoute, hasMessages }: LandingViewArgs): boolean {
  return (isLandingRoute || isNewChatRoute) && !hasMessages
}
